import Proxy from './Proxy';

class MailSentProxy extends Proxy {
    constructor(parameters = {}) {
        super('/mail-sent', parameters);
    }
}

export default MailSentProxy;
